<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    stroke="currentColor"
    fill="currentColor"
  >
    <path
      d="M265.5,209.4l32.1-60.5l32.1,60.5c9.4,17.6,2.5,39.4-15.2,48.6c-17.8,9.3-39.7,2.5-49.1-15.1
		C259.9,232.5,259.9,219.9,265.5,209.4L265.5,209.4z M297.7,271.6c25.3,0,45.8-20.3,45.8-45.3c0-7.4-1.8-14.7-5.3-21.2l-36.3-68.4
		c-1.2-2.3-4.1-3.2-6.4-1.9c-0.8,0.4-1.5,1.1-2,1.9L257.1,205c-11.8,22.2-3.2,49.6,19.1,61.3C282.9,269.8,290.2,271.6,297.7,271.6"
    />
    <path
      d="M156,154.3l16.1-30.3l16.1,30.3c4.7,8.8,1.4,19.7-7.5,24.4c-7.1,3.8-15.9,2.4-21.5-3.2
		C153.6,169.9,152.3,161.3,156,154.3L156,154.3z M152.6,182.1c10.9,10.7,28.4,10.6,39.1-0.2c8.5-8.5,10.5-21.4,4.9-32l-20.2-38.2
		c-1.2-2.3-4.1-3.2-6.4-1.9c-0.8,0.4-1.5,1.1-2,1.9l-20.3,38.2C141.9,160.6,144,173.7,152.6,182.1"
    />
    <path
      d="M358.2,373.3c3.6,4.5,7.9,8.6,12.6,12c2.3,1.3,5.2,0.6,6.5-1.7c1.2-2.1,0.7-4.7-1.3-6.1
		c-4-2.9-7.6-6.4-10.7-10.3c-7.1-8.1-15.2-17.3-31.1-17.3c-15.9,0-24,9.1-31.1,17.3c-6.6,7.5-12.3,14-23.9,14
		c-11.6,0-17.3-6.5-23.9-14c-7.1-8.1-15.2-17.3-31.1-17.3c-15.9,0-24,9.2-31,17.3c-6.6,7.5-12.3,14-23.9,14
		c-11.6,0-17.3-6.5-23.9-14c-4.5-5.7-10.1-10.4-16.5-13.9c-2.4-1.1-5.2-0.2-6.4,2.2c-1.1,2.3-0.2,5.2,2.2,6.3c5.2,3,9.7,7,13.3,11.8
		c7.1,8.1,15.2,17.3,31.1,17.3s24-9.3,31.1-17.4c6.6-7.5,12.3-14,23.9-14c11.6,0,17.3,6.5,23.9,14c7.1,8.1,15.2,17.3,31.1,17.3
		s23.9-9.2,31-17.3c6.6-7.5,12.3-14,23.9-14C345.8,359.3,351.6,365.8,358.2,373.3"
    />
    <path
      d="M129.2,300c-2.4-1.1-5.2-0.2-6.4,2.2c-1.1,2.3-0.2,5.2,2.2,6.3c5.2,3,9.7,7,13.3,11.8
		c7.1,8.1,15.2,17.3,31.1,17.3s24-9.3,31.1-17.4c6.6-7.5,12.3-14,23.9-14c11.6,0,17.3,6.5,23.9,14c7.1,8.1,15.2,17.3,31.1,17.3
		c15.9,0,23.9-9.2,31-17.3c6.6-7.5,12.3-14,23.9-14c11.6,0,17.3,6.5,23.9,14.1c3.6,4.5,7.9,8.6,12.6,12c2.3,1.3,5.2,0.6,6.5-1.7
		c1.2-2.1,0.7-4.7-1.3-6.1c-4-2.9-7.6-6.4-10.7-10.3c-7.1-8.1-15.2-17.3-31.1-17.3c-15.9,0-23.9,9.1-31,17.2
		c-6.6,7.5-12.3,14-23.9,14c-11.6,0-17.3-6.5-23.9-14c-7.1-8.1-15.2-17.3-31.1-17.3s-23.9,9.2-30.9,17.3c-6.6,7.5-12.3,14-23.9,14
		c-11.6,0-17.3-6.5-23.9-14C141.2,308.2,135.6,303.5,129.2,300"
    />
  </svg>
</template>
